/** The product's name and home since 1.15 (before: "SweetHomeHub" on sweethomehub.web.app). */
export const APP_NAME = 'Larovi Home';
export const APP_HOST = 'app.larovihome.com';
export const APP_ORIGIN = `https://${APP_HOST}`;
/** The website (Impressum, Datenschutz, waitlist) – larovihome.com once the domain points there. */
export const SITE_ORIGIN = 'https://larovihome.com';

/** Addresses the app lived at before – they only show "Wir sind umgezogen" now. */
const OLD_HOSTS = new Set([
  'sweethomehub.web.app',
  'sweethomehub.firebaseapp.com',
  'sweethomehub-staging.web.app',
  'sweethomehub-staging.firebaseapp.com',
]);

/**
 * Where this page lives now, or undefined if it is not an old address. Path and query stay,
 * so a bookmark of /kalender leads to /kalender. Previews (…--pr-12-….web.app) and localhost
 * are not old addresses.
 */
export function movedTarget(
  location: { hostname: string; pathname: string; search: string },
  /** One more old address – the e2e suite uses a *.localhost name (.web.app is https-only). */
  extraOldHost?: string,
): string | undefined {
  if (!OLD_HOSTS.has(location.hostname) && location.hostname !== extraOldHost) return undefined;
  return `${APP_ORIGIN}${location.pathname}${location.search}`;
}
